import React, {useState} from 'react';
import {Box, Button} from '@mui/material';
import NationalDashboardShell from '../components/NationalDashboard.comp';
import CircularLoader from '../../../components/CircularLoader';
import NoDataAvailable from '../../../components/NoDataAvailable';
import TakeActionFlow from '../../DQPro/PerformanceSummary/TakeActionFlow.comp';
import {useDashboard} from '../../../context/DashboardContext';
import {findCard, rowMatches, isScopeSuppressed} from '../../DashboardCommon/dashboardCards';
import {TEAL, PageHeader} from '../components/widgets.comp';
import {priorityRows, PriorityTable, SUPPRESSED_EMPTY} from '../components/PriorityTable.comp';

/* Slide 37 — Recommended Learning Programs (National). Live rows: ND.S_15.C_2
   (PriorityTableCard, every current whole-school learning-program recommendation
   of the partner's schools in this country). National's hierarchy is Region →
   School — there is no Country column (unlike Network / Partner). Every column
   sorts and filters from its header and the search box matches any cell (QA
   9 Oct 2026; the old drop-down filter bar is gone). Take Action is a School
   Dashboard action; the card says so
   (take_action false), so the button only appears when a card asks for it. */
const PRIORITY_ACTIONS_LP_SECTION_CODE = 'S_15';
const CARD_SECTIONS = [PRIORITY_ACTIONS_LP_SECTION_CODE];
const RECOMMENDATION_HEADER = 'Recommended Learning';

const PriorityActionsLearningProgramPage = () => {
    const {dashboardData, loading} = useDashboard({ card_sections: CARD_SECTIONS });
    const card = findCard(dashboardData, PRIORITY_ACTIONS_LP_SECTION_CODE, 'C_2');
    const [query, setQuery] = useState('');
    const rows = priorityRows(card, RECOMMENDATION_HEADER);
    const q = query.trim().toLowerCase();
    const shown = rows.filter((r) => rowMatches(r, q));

    if (loading) {
        return (
            <NationalDashboardShell>
                <CircularLoader />
            </NationalDashboardShell>
        );
    }

    if (!dashboardData) {
        return (
            <NationalDashboardShell>
                <NoDataAvailable />
            </NationalDashboardShell>
        );
    }

    return (
        <NationalDashboardShell>
            <PageHeader
                title="Recommended Learning Programs"
                subtitle="The crosswalk converts priority COS areas into targeted learning programs."
            />

            {card?.take_action === true && rows.length > 0 && (
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 2.5}}>
                    <TakeActionFlow>
                        {(openTakeAction) => (
                            <Button onClick={openTakeAction} sx={{textTransform: 'none', fontWeight: 700, backgroundColor: TEAL, color: '#fff', '&:hover': {backgroundColor: TEAL}}}>
                                Take Action
                            </Button>
                        )}
                    </TakeActionFlow>
                </Box>
            )}

            <PriorityTable rows={shown} recommendationHeader={RECOMMENDATION_HEADER} query={query} onQuery={setQuery} emptyText={isScopeSuppressed(dashboardData) ? SUPPRESSED_EMPTY : undefined}/>
        </NationalDashboardShell>
    );
};

export default PriorityActionsLearningProgramPage;
